<template>
    <article class="accordion" :class="{ 'accordion--open' : isOpen }">
        <header @click.prevent="toggle" class="accordion__header">
            <div class="accordion__header__row">
                <p class="accordion__title">{{ job.title }}</p>
                <transition name="pulse">
                    <div :key="notifications.length" class="badge badge--warning accordion__count">{{ notifications.length }} update{{ notifications.length > 1 ? 's' : '' }}</div>
                </transition>
            </div>
            <div class="accordion__header__row">
                <p class="accordion__meta"><span>in</span> {{ channel.name }}</p>
                <a href="#" @click.prevent.stop="read" class="notifications__action">Mark as read</a>
            </div>
        </header>
        <transition name="accordion" @before-enter="beforeEnter" @enter="enter" @before-leave="beforeLeave" @leave="leave">
            <footer v-if="isOpen" class="accordion__footer">
                <notification v-for="notification in notifications" :key="notification.id" :notification="notification"/>
            </footer>
        </transition>
    </article>
</template>

<script>
import Toggleable from '../../mixins/toggle'
import Notification from './Notification'

export default {
    name: 'Accordion',

    mixins: [
        Toggleable
    ],

    props: {
        job: {
            required: true,
            type: Object
        },

        notifications: {
            required: true,
            type: Array
        }
    },

    methods: {
        beforeEnter (el) {
            el.style.height = '0'
        },
        enter (el) {
            el.style.height = el.scrollHeight + 12 + 'px'
        },
        beforeLeave (el) {
            el.style.height = el.scrollHeight + 12 + 'px'
        },
        leave (el) {
            el.style.height = '0'
        },

        read () {
            this.$store.dispatch('notifications/readJobNotifications', this.job.id)
        }
    },

    computed: {
        channel () {
            return this.notifications[0].channel
        }
    },

    components: {
        Notification
    }
}
</script>

<style scoped lang="less">
    * {
        backface-visibility: hidden;
        will-change: height;
    }
</style>
